import React from "react";
import EvaEntityCreate from "modules/eva/containers/EvaEntityCreate";

interface EvaEntityCreatePageProps {
  isSkillMode?: boolean;
}

const EvaEntityCreatePage: React.FC<EvaEntityCreatePageProps> = ({ isSkillMode = false }) => {
  return <EvaEntityCreate isSkillMode={isSkillMode} />;
};

export default EvaEntityCreatePage;
